import React, { Component } from 'react';
import { reduxForm, Field } from 'redux-form';
import { I18n } from 'react-redux-i18n';
import { css } from 'aphrodite/no-important';
import logo from '../../../assets/logo_white.png';
import styles from './ForgotPasswordForm.styles';
import { UserValidations } from '../../../models';

import Image from '../../common/image/Image';
import LoginButton from '../../inputs/loginbutton/LoginButton';
import LoginInput from '../../inputs/logininput/LoginInput';

export class ForgotPasswordForm extends Component {
  render() {
    return (
      <form className={css(styles.form)} onSubmit={this.props.handleSubmit}>
        <Image src={logo} alt="logo" styles={styles.logo} />
        <p className={css(styles.p)}>{I18n.t('forgotPassword.txt')}</p>
        <Field
          name="email"
          type="text"
          placeholder={I18n.t('login.email')}
          validate={UserValidations.email}
          component={LoginInput}
        />
        <div
          className={css(
            styles.actions,
            this.props.createError && styles.actionsError
          )}
        >
          <LoginButton>{I18n.t('forgotPassword.reset')}</LoginButton>
        </div>
      </form>
    );
  }
}

export default reduxForm({
  form: 'forgotpassword'
})(ForgotPasswordForm);



// WEBPACK FOOTER //
// ./src/components/forms/forgotpassword/ForgotPasswordForm.js